import { Box, Container, Flex, Grid, GridItem } from "@chakra-ui/react";
import React from "react";
import { Text } from "@chakra-ui/react";
import myImg from "../Images/newImg.png";
import styled from "styled-components";

export const About = () => {
  return (
    <Container
      color="black"
      bg="black"
      // border="1px solid blue"
      h={{ base: "auto", md: "auto", lg: "85vh" }}
      maxW="100%"
      id="about"
      className="about section"
      display={"flex"}
      flexDirection = "column"
      gap = {{base: "0", md: "0", lg: "10%"}}
    >
      <Text
        // fontSize="40px"
        fontSize={{ base: "22px", sm: "24px", md: "30px", lg: "50px" }}
        color="white"
        fontFamily="'Mogra', cursive"
      >
        Let me help you know more about me...
      </Text>
      <Flex
        gap={{ base: 5, lg: 15 }}
        p="10"
        alignItems="center"
        justifyContent="space-between"
        direction={{ base: "column", lg: "row" }}
        // border = "1px solid red"
      >
        <Box
          pos="relative"
          width={{ base: "55%", md: "30%", lg: "90%" }}
          border="2px double white"
          h="auto"
          borderRadius={"50%"}
          overflow = "hidden"
          bg = "white"
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover", position : "relative", right : "3%", transform : "rotate(-1deg)"}}
            src={myImg}
            alt=""
          />
        </Box>
        <Flex
          flexDirection="column"
          data-aos="fade-down"
          gap={{ base: 5, lg: 10 }}
          color="white"
          id="user-detail-intro"
        >
          <Text display="none">About</Text>
          <Text
            textAlign="center"
            id="user-detail-intro"
            fontSize={{ base: "15px", md: "20px", lg: "26px" }}
          >
            Highly skilled Full Stack Web Developer proficient in MERN stack
            (MongoDB, Express.js, React.js, Node.js) with a command of
            JavaScript. Collaborative team player with strong problem-solving
            and communication skills. Proactive approach and motivation to
            leverage latest technologies and best practices to create innovative
            web solutions. Proficient in Generative AI. Basic knowledge of
            Python and Flask.
          </Text>

          <Grid
            placeItems="center"
            // p={5}
            p={{ base: 2, lg: 5 }}
            gap={{ base: 3, lg: 10 }}
            gridTemplateColumns={{ base: "repeat(2,1fr)", lg: "repeat(4,1fr)" }}
            // border="1px solid white"
          >
            <GridItem>
              <GridImg
                src="https://img.icons8.com/pulsar-color/256/code-folder.png"
                alt=""
              />
              <Text fontSize={{ base: "15px", lg: "20px" }}>1200+ Hours</Text>
              <Text fontSize={{ base: "15px", lg: "20px" }}>
                Practical Coding
              </Text>
            </GridItem>
            <GridItem>
              <GridImg
                src="https://img.icons8.com/external-filled-line-andi-nur-abdillah/256/external-Communication-hospital-(filled-line)-filled-line-andi-nur-abdillah.png"
                alt=""
              />
              <Text
                width={{ base: "100%" }}
                fontSize={{ base: "15px", lg: "20px" }}
              >
                100+ Hours
              </Text>
              <Text fontSize={{ base: "15px", lg: "20px" }}>
                Soft-Skills Dev.
              </Text>
            </GridItem>
            <GridItem>
              <GridImg
                src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/256/external-soft-skills-recruitment-agency-flaticons-lineal-color-flat-icons-2.png"
                alt=""
              />
              <Text fontSize={{ base: "15px", lg: "20px" }}>100+ Hours</Text>
              <Text fontSize={{ base: "15px", lg: "20px" }}>DSA</Text>
            </GridItem>
            <GridItem>
              <GridImg
                src="https://img.icons8.com/plasticine/256/idea.png"
                alt=""
              />
              <Text fontSize={{ base: "15px", lg: "20px" }}>
                4+ Major Projects
              </Text>
              <Text fontSize={{ base: "15px", lg: "20px" }}>
                30+ Mini Projects
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </Flex>
    </Container>
  );
};

const GridImg = styled.img`
  width: 30%;
  margin: auto;

  @media screen and (max-width: 480px) {
    width: 20%;
  }
`;
